import React from 'react';

export function MouseClickIcon(props: JSX.IntrinsicElements['svg']) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 22 21"
            width={22}
            height={21}
            {...props}
        >
            <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
                <path d="M16.26 19.94a.43.43 0 01-.14.23.47.47 0 01-.52.05.45.45 0 01-.2-.19l-4.93-9.43a.42.42 0 01.08-.5.48.48 0 01.53-.08l9.87 4.71c.08.04.15.1.2.18a.42.42 0 01-.06.5.46.46 0 01-.24.14l-3.68.88-.91 3.51z" />
                <path d="M9.86 17.74c-1.72 0-3.4-.49-4.83-1.4a8.4 8.4 0 01-3.2-3.73 7.98 7.98 0 01-.5-4.8 8.2 8.2 0 012.38-4.26 9.06 9.06 0 019.47-1.8 8.62 8.62 0 013.9 3.06 8.06 8.06 0 011.47 4.62" />
                <path d="M8.55 14.07a5.09 5.09 0 01-2.25-1.24 4.61 4.61 0 01-.01-6.8 5.25 5.25 0 017.1-.03c.63.6 1.08 1.33 1.31 2.15" />
            </g>
        </svg>
    );
}
